import axios from "axios";

const TOKEN = 'ccktub2ad3ia99mmbofgccktub2ad3ia99mmbog0'

export default axios.create({
  baseURL: 'https://finnhub.io/api/v1',
  params: {
    token: TOKEN
  }
})
